export const setVisibleLayer = function(materialId, layerIndex, value){
  const v = Number(value);

  this.dataScene.scene.materials.find(mtl => mtl.id === materialId)
    .layers[layerIndex].settings.designMapOpacity.visible.value = v;
};
